//WhistleBlowArchiveSelectTypeDialog
//***********************************************************************************************************************
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import * as React from "react";
import { WhistleBlowArchivingType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog } from "../../framework/Dialog/Dialog";

//WhistleBlowArchiveSelectTypeDialog
export interface IWhistleBlowArchiveSelectTypeDialogProps {
    classes?: string;
    type1Disabled?: boolean;
    type2Disabled?: boolean;
    onOk: (archivingType: WhistleBlowArchivingType) => void;
    onCancel: () => void;
}

export interface IWhistleBlowArchiveSelectTypeDialogState {
    archivingType: WhistleBlowArchivingType;
}

export class WhistleBlowArchiveSelectTypeDialog extends React.Component<IWhistleBlowArchiveSelectTypeDialogProps, IWhistleBlowArchiveSelectTypeDialogState> {
    constructor(props: IWhistleBlowArchiveSelectTypeDialogProps) {
        super(props);
        this.state = {
            archivingType: WhistleBlowArchivingType.ChangeStateAndRemoveAllData
        };
    }

    handleChange = (checked: boolean, archivingType: WhistleBlowArchivingType) => {
        if (!checked) return;
        this.setState({
            archivingType
        });
    };

    handleCancel = () => {
        this.props.onCancel();
    };

    handleOk = async () => {
        const state = this.state;
        this.props.onOk(state.archivingType);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Dialog
                id="wb-archive-type-dialog"
                maxWidth="sm"
                title={Translations.SelectArchivingMethod}
                body={
                    <RadioGroup value={state.archivingType}>
                        {!props.type1Disabled &&
                            <FormControlLabel
                                value={WhistleBlowArchivingType.ChangeState}
                                control={<Radio />}
                                label={Translations.WhistleBlowArchivingTypeChangeState}
                                onClick={() => this.handleChange(true, WhistleBlowArchivingType.ChangeState)}
                            />
                        }
                        {!props.type2Disabled &&
                            <FormControlLabel
                                value={WhistleBlowArchivingType.ChangeStateAndRemoveInformantData}
                                control={<Radio />}
                                label={Translations.WhistleBlowArchivingTypeChangeStateAndRemoveInformantData}
                                onClick={() => this.handleChange(true, WhistleBlowArchivingType.ChangeStateAndRemoveInformantData)}
                            />
                        }
                        <FormControlLabel
                            value={WhistleBlowArchivingType.ChangeStateAndRemoveAllData}
                            control={<Radio />}
                            label={Translations.WhistleBlowArchivingTypeChangeStateAndRemoveAllData}
                            onClick={() => this.handleChange(true, WhistleBlowArchivingType.ChangeStateAndRemoveAllData)}
                        />
                    </RadioGroup>
                }
                buttons={[
                    { title: Translations.Cancel, variant: "outlined", onClick: this.handleCancel },
                    { title: Translations.OK, variant: "confirmation", onClick: this.handleOk },
                ]}
                onClose={this.handleCancel}
            />
        );
    }
}